import { HERO, PLACE_RIBBON } from "../../data/content";
import { Link } from "react-router-dom";

export const Hero = () => {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-[100svh] w-full overflow-hidden bg-forest"
        >
            <img
                src={HERO.image}
                alt="Dawn over the eastern Himalayas in Arunachal Pradesh"
                className="absolute inset-0 h-full w-full object-cover animate-slow-zoom"
                loading="eager"
                fetchPriority="high"
                decoding="async"
            />
            {/* layered gradient for legibility without flat overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-forest/95 via-forest/55 to-forest/35" />
            <div className="absolute inset-0 bg-gradient-to-b from-forest/40 via-transparent to-transparent" />

            <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 min-h-[100svh] flex flex-col justify-end pb-24 md:pb-32">
                <div className="max-w-4xl animate-fade-up">
                    <p
                        data-testid="hero-eyebrow"
                        className="text-paper/85 text-xs md:text-sm uppercase tracking-[0.32em] hero-shadow mb-8"
                    >
                        {HERO.eyebrow}
                    </p>
                    <h1
                        data-testid="hero-title"
                        className="font-serif text-paper hero-shadow text-[44px] sm:text-6xl md:text-7xl lg:text-[110px] leading-[0.95] tracking-tighter font-light"
                    >
                        {HERO.title_lines.map((line, i) => (
                            <span key={i} className="block">
                                {i === 1 ? <em className="italic text-marigold">{line}</em> : line}
                            </span>
                        ))}
                    </h1>
                    <p
                        data-testid="hero-sub"
                        className="mt-10 max-w-xl text-paper/85 text-base md:text-lg hero-shadow"
                    >
                        {HERO.sub}
                    </p>

                    <div className="mt-12 flex flex-wrap items-center gap-5">
                        <Link
                            to="/journeys"
                            data-testid="hero-discover-cta"
                            className="inline-flex items-center gap-3 bg-paper text-forest px-7 py-4 text-[12px] uppercase tracking-[0.22em] hover:bg-marigold transition-all duration-300 hover:-translate-y-0.5"
                        >
                            Begin the journey
                            <span aria-hidden>→</span>
                        </Link>
                        <a
                            href="#plan"
                            data-testid="hero-plan-cta"
                            className="inline-flex items-center gap-3 text-paper px-2 py-4 text-[12px] uppercase tracking-[0.22em] border-b border-paper/40 hover:border-marigold hover:text-marigold transition-all"
                        >
                            Speak with a curator
                        </a>
                    </div>
                </div>
            </div>

            {/* place-name marquee */}
            <div className="absolute bottom-0 inset-x-0 z-10 border-t border-paper/15 bg-forest/40 backdrop-blur-sm overflow-hidden">
                <div className="marquee-track flex whitespace-nowrap py-3 text-paper/70 text-[11px] uppercase tracking-[0.4em]">
                    {[...PLACE_RIBBON, ...PLACE_RIBBON].map((p, i) => (
                        <span key={i} className="px-7 flex items-center">
                            {p}
                            <span className="ml-7 text-marigold/60">·</span>
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};
